// Admin Management and Campaign Access Configuration
// Emails are case-insensitive

// Emails that have access to Admin Management (managing other admins)
export const ADMIN_MANAGEMENT_EMAILS = [
  'dev@team.com',
  // Add more authorized emails below:
];

// Emails that have access to Campaigns
export const CAMPAIGN_ACCESS_EMAILS = [
  'dev@team.com',
  'bigbirdvr@gmail.com',
];

// Emails that have access to News management
export const NEWS_ACCESS_EMAILS = [
  'dev@team.com',
  'bigbirdvr@gmail.com',
];

// Emails that have full News management scope regardless of their geographic adminScope
export const NEWS_FULL_SCOPE_EMAILS = [
  'bigbirdvr@gmail.com',
];

// Emails that have full Campaign management scope regardless of their geographic adminScope
export const CAMPAIGN_FULL_SCOPE_EMAILS = [
  'bigbirdvr@gmail.com',
];

// Helper function to check if an email has admin management access
export const hasAdminManagementAccess = (email) => {
  if (!email) return false;
  const normalizedEmail = email.toLowerCase().trim();
  return ADMIN_MANAGEMENT_EMAILS.some(
    (authorizedEmail) => authorizedEmail.toLowerCase().trim() === normalizedEmail
  );
};

// Helper function to check if an email has campaign management access
export const hasCampaignAccess = (email) => {
  if (!email) return false;
  const normalizedEmail = email.toLowerCase().trim();
  return CAMPAIGN_ACCESS_EMAILS.some(
    (authorizedEmail) => authorizedEmail.toLowerCase().trim() === normalizedEmail
  );
};

// Helper function to check if an email has News management access
export const hasNewsAccess = (email) => {
  if (!email) return false;
  const normalizedEmail = email.toLowerCase().trim();
  return NEWS_ACCESS_EMAILS.some(
    (authorizedEmail) => authorizedEmail.toLowerCase().trim() === normalizedEmail
  );
};

// Helper function to check if an email has full News scope
export const hasNewsFullScope = (email) => {
  if (!email) return false;
  const normalizedEmail = email.toLowerCase().trim();
  return NEWS_FULL_SCOPE_EMAILS.some(
    (authorizedEmail) => authorizedEmail.toLowerCase().trim() === normalizedEmail
  );
};

// Helper function to check if an email has full Campaign scope
export const hasCampaignFullScope = (email) => {
  if (!email) return false;
  const normalizedEmail = email.toLowerCase().trim();
  return CAMPAIGN_FULL_SCOPE_EMAILS.some(
    (authorizedEmail) => authorizedEmail.toLowerCase().trim() === normalizedEmail
  );
};
